import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg, sbkCoreBreakpointMd, sbkCoreBreakpointXl} from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const style = css`
  .cookie-consent-overlay {
    height: 400px;

    .cookie-consent-overlay-inner {
      .cookie-consent-overlay-button {
        margin-top: var(--sbkCoreSizingMd);
      }
    }
  }

  .cookie-consent-overlay-background-image {
    color: var(--sbkColorContentFgColorOnDarkDefault);
    display: flex;
    align-items: center;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .cookie-consent-overlay-background {
      position: absolute;
      z-index: 0;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: var(--sbkCoreColorGrey500);
      opacity: 0.5;
      margin: 0 var(--sbkCoreGridSmMargin);

      @media all and (min-width: ${breakpointMd}) {
        margin: 0 var(--sbkCoreGridMdMargin);
      }

      @media all and (min-width: ${breakpointLg}) {
        margin: 0 var(--sbkCoreGridLgMargin);
      }
      @media all and(min-width: ${breakpointXl}) {
        margin: 0 var(--sbkCoreGridXlMargin);
      }
    }

    .cookie-consent-overlay-inner {
      z-index: 1;

      .cookie-consent-overlay-inner-container {
        padding: var(--sbkCoreSizing5xl) var(--sbkCoreSizing2xl);

        @media all and (max-width: var(--sbkCoreBreakpointMd)) {
          padding: var(--sbkCoreSizingMd);
        }
      }

      .cookie-consent-overlay-button {
        margin-top: var(--sbkCoreSizingMd);
      }
    }
  }
`;